import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

// Actions
export const FETCH_SYSTEM_SETTINGS = 'FETCH_SYSTEM_SETTINGS';
export const FETCH_SYSTEM_SETTINGS_SUCCESS = 'FETCH_SYSTEM_SETTINGS_SUCCESS';
export const FETCH_SYSTEM_SETTINGS_FAIL = 'FETCH_SYSTEM_SETTINGS_FAIL';
export const UPDATE_SYSTEM_SETTINGS = 'UPDATE_SYSTEM_SETTINGS';
export const UPDATE_SYSTEM_SETTINGS_SUCCESS = 'UPDATE_SYSTEM_SETTINGS_SUCCESS';
export const UPDATE_SYSTEM_SETTINGS_FAIL = 'UPDATE_SYSTEM_SETTINGS_FAIL';

// Reducer
export default function systemSettingsReducer(state = { data: {}, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_SYSTEM_SETTINGS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_SYSTEM_SETTINGS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_SYSTEM_SETTINGS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case UPDATE_SYSTEM_SETTINGS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchSystemSettings(payload) {
  return { type: FETCH_SYSTEM_SETTINGS, payload };
}

export function fetchSystemSettingsSuccess(payload) {
  return { type: FETCH_SYSTEM_SETTINGS_SUCCESS, payload };
}

export function fetchSystemSettingsFail(payload) {
  return { type: FETCH_SYSTEM_SETTINGS_FAIL, payload };
}

export function updateSystemSettings(payload) {
  return { type: UPDATE_SYSTEM_SETTINGS, payload };
}

export function updateSystemSettingsSuccess(payload) {
  return { type: UPDATE_SYSTEM_SETTINGS_SUCCESS, payload };
}

export function updateSystemSettingsFail(payload) {
  return { type: UPDATE_SYSTEM_SETTINGS_FAIL, payload };
}

// Requests
export function requestFetchSystemSettings() {
  return callApi('settings/settings_app/');
}

export function requestUpdateSystemSettings(payload) {
  return callApi('settings/settings_app/', 'PUT', payload);
}

// Sagas
function* fetchSystemSettingsSaga(action) {
  const { triggerLoading, recoverOrderValues } = action.payload;
  try {
    const res = yield call(requestFetchSystemSettings);
    yield put(fetchSystemSettingsSuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    if (err.data.error === 'Access Error' && recoverOrderValues) {
      yield put(saveRecoverOrder(recoverOrderValues));
    }
    yield put(fetchSystemSettingsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* updateSystemSettingsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateSystemSettings, values);
    yield put(updateSystemSettingsSuccess({
      data: res.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'System settings successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateSystemSettingsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* systemSettingsSaga() {
  yield takeEvery(FETCH_SYSTEM_SETTINGS, fetchSystemSettingsSaga);
  yield takeEvery(UPDATE_SYSTEM_SETTINGS, updateSystemSettingsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/systemSettings.js